import * as Yup from 'yup';
import moment from 'moment';
import { get } from 'lodash';
import { trims } from '../../../../utils';

Yup.addMethod(Yup.string, 'uniqueOrders', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueOrders', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, 'cranes');

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    list?.forEach((doc: any) => {
      const val = trims(String(doc.name));
      if (uniqValues.includes(val) && !doubles.includes(val)) {
        doubles.push(val);
      } else {
        uniqValues.push(val);
      }
    });
    if (!doubles.includes(trims(obj || ''))) return true;

    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

const validateResourcesSchema = Yup.object().shape({
  cranes: Yup.array().of(
    Yup.object().shape({
      locationId: Yup.number().required('Поле "Склад" обов\'язкове'), // @ts-ignore
      name: Yup.string().nullable().uniqueOrders().required('Поле "Назва" обов\'язкове'),
      accessibilityRowMin: Yup.number().nullable().required("Обов'язкове поле"),
      accessibilityRowMax: Yup.number()
        .nullable()
        .required("Обов'язкове поле")
        .when('accessibilityRowMin', (accessibilityRowMin: number, schema: any) =>
          schema.test({
            test: (accessibilityRowMax: any) => !!accessibilityRowMin && accessibilityRowMax > accessibilityRowMin,
            message: 'Значення поля повинно бути більше попереднього',
          }),
        ),
      startFrom: Yup.mixed().when('stopFrom', (stopFrom: any, schema: any) =>
        schema.test({
          test: (startFrom: any) => !!moment(startFrom).unix() && moment(stopFrom).unix() < moment(startFrom).unix(),
          message: 'Значення поля повинно бути більше попереднього',
        }),
      ),
      stopFrom: Yup.mixed(),
    }),
  ),
});

export default validateResourcesSchema;
